// extracted by mini-css-extract-plugin
export default {"recos":"R2-z","productCardOverride":"S2-z","rowHasBadge":"T2-z"};